var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inS3Storage)?_c('amplify-s3-image',{attrs:{"img-key":_vm.imgKey}}):_c('b-card-img',{attrs:{"src":_vm.imageUrl,"height":"300","alt":"Product Image","img-top":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }